import React from 'react'
import { Footer } from './Footer'
import { Alert } from '@ztechapps/webui.util'
import { List } from './List'

export const Layout = () => {
  return (
    <React.Fragment>
      <Alert type="warning">
        <ul>
          <li className="small">Add a descriptive task name</li>
          <li className="small">You can add multiple tasks and all of them will included to a single project. </li>
        </ul>
      </Alert>

      <List />
      <hr />
      <Footer />
    </React.Fragment>
  )
}
